import React, { useState } from 'react';
import { apiService } from '../../components/Config/api.service';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        apiService.authenticate(email, password)
            .then((response) => {
                localStorage.setItem("access_token", response.data.access_token);
                localStorage.setItem("refresh_token", response.data.refresh_token);
                if (response) {
                    localStorage.setItem('isConnected', true);
                    window.location.href = '/';
                } else {
                    console.log('Authentification échouée');
                    setErrorMessage('Informations de connexion incorrectes');
                    setLoading(false);
                }
            }).catch(err => {
                setLoading(false);
                console.log('  ERROR ', err);
                console.log('Authentification échouée');
                setErrorMessage('Informations de connexion incorrectes');
            })
    };

    return (
        <div className="w-full flex items-center justify-center p-8">
            <div className="w-full max-w-md">

                <div className="bg-white shadow-lg rounded-xl p-8">
                    <a href="/" className="text-4xl text-[--color-primary] font-extrabold inline-flex items-center">
                        YROS
                    </a>
                    <div className="mb-6 mt-3">
                        <h2 className="text-2xl font-bold text-gray-800">Se connecter</h2>
                        <p className="text-gray-600 mt-2">Saisissez vos informations pour accéder à votre espace</p>
                    </div>

                    {errorMessage && (
                        <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded flex items-center">
                            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                            </svg>
                            {errorMessage}
                        </div>
                    )}

                    {loading ? (
                        <div className="flex justify-center py-8">
                            <div className="relative w-16 h-16">
                                <div className="absolute top-0 w-full h-full border-4 border-gray-200 rounded-full"></div>
                                <div className="absolute top-0 w-full h-full border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="formEmail" className="block text-sm font-medium text-gray-700 mb-2">
                                    Adresse email
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <svg className="h-5 w-5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                                        </svg>
                                    </div>
                                    <input
                                        type="email"
                                        id="formEmail"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition-all"
                                        placeholder="exemple@email.com"
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="formPassword" className="block text-sm font-medium text-gray-700 mb-2">
                                    Mot de passe
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <svg className="h-5 w-5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                        </svg>
                                    </div>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="formPassword"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        className="block w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition-all"
                                        placeholder="••••••••••"
                                    />
                                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="text-gray-400 hover:text-gray-600 focus:outline-none"
                                        >
                                            {showPassword ? (
                                                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                                </svg>
                                            ) : (
                                                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <input
                                        id="remember-me"
                                        name="remember-me"
                                        type="checkbox"
                                        className="h-4 w-4 text-[--color-primary] focus:ring-blue-600 border-gray-300 rounded"
                                    />
                                    <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
                                        Se souvenir de moi
                                    </label>
                                </div>
                                <div className="text-sm">
                                    <a href="#" className="font-medium text-[--color-primary] hover:text-blue-800">
                                        Mot de passe oublié ?
                                    </a>
                                </div>
                            </div>

                            <div className="flex flex-col space-y-4">
                                <button
                                    type="submit"
                                    className="w-full bg-[--color-primary] hover:bg-[--color-orange] text-white py-3 px-4 rounded-lg font-medium transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 active:translate-y-0"
                                >
                                    Se connecter
                                </button>

                                <div className="flex items-center justify-center space-x-2">
                                    <span className="bg-gray-200 h-px flex-1"></span>
                                    <span className="text-gray-500 text-sm px-4">ou</span>
                                    <span className="bg-gray-200 h-px flex-1"></span>
                                </div>

                                <a
                                    href="/inscription"
                                    className="w-full flex justify-center items-center py-3 px-4 border border-gray-300 rounded-lg shadow-sm bg-white hover:bg-gray-50 font-medium text-gray-700 transition-all"
                                >
                                    Créer un compte
                                </a>
                            </div>
                        </form>
                    )}
                </div>

                <div className="mt-6 text-center text-sm text-gray-500">
                    En vous connectant, vous acceptez nos{' '}
                    <a href="#" className="text-[--color-primary] hover:underline">Conditions d'utilisation</a> et notre{' '}
                    <a href="#" className="text-[--color-primary] hover:underline">Politique de confidentialité</a>.
                </div>
            </div>
        </div>
    );
};

export default Login;